export const referralCareDirectoryRoutePrefixes = [
  "/care",
  "/referrer",
  "/biz/dashboard",
  "/b/:businessUrl/care",
];
